import Vue from "vue";
import moment from "moment-jalaali";

Vue.filter("priceSplitter", val => {
  val += "";
  val = val.replace(",", "");
  let x = val.split(".");
  let y = x[0];
  let z = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
  return y + z;
});

Vue.filter("moment", val => {

  var temp = moment(val).locale("fa");
  return temp.format("jYYYY/jM/jD ساعت:  HH:mm");
});
Vue.filter("paymentStatusConvert", val => {

  if (val == "Done") {
    return 'موفق'
  } else if (val == "WaitingForPay") {
    return ' در انتظار پرداخت'
  } else if (val == "Paid") {
    return 'پرداخت شده'
  } else if (val == "Canceled") {
    return 'لغو شده'
  } else if (val == "ReadyToSend") {
    return 'آماده ارسال'
  } else if (val == "Failed") {
    return 'ناموفق'
  } else if (val == "Processing") {
    return 'در حال پردازش'
  } else if (val == "Delivered") {
    return 'تحویل شده'
  } else if (val == "Canceled") {
    return 'لغو شده'
  } else if (val == "Returned") {
    return 'مرجوعی'
   } else if (val == "WaitingForVerify") {
    return 'در انتظار تایید'
  } else if (val == "Returned") {
    return 'مرجوعی'
  } else if (val == "Posted") {
    return 'ارسال شده'
  } else if (val == "CanceledBySupplier") {
    return 'کنسل شده توسط تامین کننده'
  } else if (val == "CanceledByCustomer") {
    return 'کنسل شده توسط مشتری'
  } else if (val == "Archived") {
    return 'بایگانی شده'
  }
});

Vue.filter("paymentType", val => {

  if (val == "Online") {
    return 'آنلاین'
  } else if (val == "POS") {
    return ' در محل'
  } else if (val == "Cheque") {
    return 'چک'
  } else if (val == "Credit") {
    return 'اعتبار'
  } else if (val == "Other") {
    return 'سایر'
  }
});


Vue.filter("merchantEvents", val => {

  if (val == "Accessed") {
    return 'دسترسی پیدا کرد'
  } else if (val == "AccessRemoved") {
    return 'دسترسی حذف شد'
  } else if (val == "CreatorChanged") {
    return 'ادمین تغییر کرد'
  } else if (val == "MerchantEdited") {
    return 'ویرایش شد'
  } else if (val == "MerchantEnabled") {
    return 'فعال شد '
  } else if (val == "MerchantDisabled") {
    return 'غیر فعال شد '
  }
});
Vue.filter("orderType", val => {
  if (val == "Regular") {
    return 'پرداخت در محل'
  } else if (val == "Online") {
    return 'آنلاین'
  } else if (val == "Manual") {
    return 'فروش فروشگاهی'
  }
});
